import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { getSiteWithId, displayDecimal } from '../utils';
import { FormContent } from './Form';
import { Api } from '../../common/model';
import { State } from '../reducers';

const getLowerMaxHeight = (sites: Array<Api.Site>, departure?: string, arrival?: string): number | null => {
  const departureSite = getSiteWithId(sites, departure);
  const arrivalSite = getSiteWithId(sites, arrival);
  const values = [departureSite?.maxHeight, arrivalSite?.maxHeight].filter((x): x is number => !!x);
  return values.length > 0 ? Math.min(...values) : null;
};

const SiteInfo: FC = () => {
  const { t } = useTranslation();
  const sites = useSelector((state: State) => state.sites.sites);
  const departure = useSelector((state: State) => state.booking.departure) as FormContent;
  const arrival = useSelector((state: State) => state.booking.arrival) as FormContent;

  if (departure.site || arrival.site) {
    const maxHeight = getLowerMaxHeight(sites, departure.site, arrival.site);
    if (maxHeight) {
      const displayMaxHeight = displayDecimal(maxHeight);
      return (
        <div className="site-info">
          <svg>
            <use xlinkHref="#icon__info" />
          </svg>
          {`${t('booking-park_max_height')}: ${displayMaxHeight} m. ${t('booking-park_max_height_info')}`}
        </div>
      );
    }
  }

  return null;
};

export default SiteInfo;
